import AppHeader from "@/components/AppHeader";

export default {
  name: "master-department-new",
  components: {
    AppHeader
  },
  created() {
    this.getCompany();
    this.department.company_id = localStorage.company_id;
  },
  data() {
    return {
      department: {
        company_id: "",
        name: "",
        name_kana: "",
        is_attendance_auto: 0
      },
      companies: "",
      getCompanisEnd: false,
      savingFlag: false
    };
  },
  methods: {
    async getCompany() {
      let data = {};
      let res = await this.$store
        .dispatch("GET_COMPANY", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.companies = res.companies;
      this.getCompanisEnd = true;
    },
    async createDepartment() {
      if (this.savingFlag) return;
      this.savingFlag = true;

      let data = this.department;
      let res = await this.$store
        .dispatch("CREATE_DEPARTMENT", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      if (res.error) {
        this.errorInfo = res.error;
      } else {
        this.$router.push({ path: "/master_department" });
      }
    },
    goMasterDepartment() {
      this.$router.push({ path: "/master_department" });
    }
  }
};
